import type { DrillSequence, Street } from "@acepoker/contract";

export function getStreetFromSequence(sequence: DrillSequence["sequence"]): Street {
  return (
    (sequence.filter((el) => el.kind === "round").at(-1)?.round || "preflop") as Street
  );
}
